<template>
  <font-awesome-icon
    icon="key"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faKey } from '@fortawesome/free-solid-svg-icons'

library.add(faKey)

export default {
  name: 'CoozzyRentIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-blue;
  }
</style>
